import type { PlacementPosition, SizeMm, Surface, SurfacePoint } from '@repo/api-contracts';
import type { PhotoDimensions, PhotoRect } from '../types';
import { cylinderCenterScale, cylinderMmToPhoto, cylinderPhotoToMm } from './cylinder-mapping';
import {
  componentRectOnPhoto,
  flatScale,
  photoToSurfaceMm,
  surfaceMmToPhoto,
} from './flat-mapping';
import { meshMmToPhoto, meshPhotoToMm, meshScale } from './mesh-mapping';

/** 표면 타입으로 분기하는 mm↔사진 변환. mesh 는 칸별 양선형 격자 변환이다. */
export const surfaceScale = (surface: Surface, photo: PhotoDimensions): SurfacePoint | null => {
  if (surface.type === 'flat') return flatScale(surface, photo);
  if (surface.type === 'cylinder') return cylinderCenterScale(surface, photo);
  return meshScale(surface, photo);
};

/** 실측 프레임 위 점(mm)을 사진 점(px)으로 보낸다. cylinder 의 뒷면·프레임 밖은 null 이다. */
export const surfaceMmToPhotoPoint = (
  surface: Surface,
  photo: PhotoDimensions,
  point: PlacementPosition,
): SurfacePoint | null => {
  if (surface.type === 'flat') return surfaceMmToPhoto(surface, photo, point);
  if (surface.type === 'cylinder') return cylinderMmToPhoto(surface, photo, point);
  return meshMmToPhoto(surface, photo, point);
};

/** 사각형으로 옮겨지는 flat 만 값이 있다. cylinder·mesh 는 휘어 사각형이 아니라 null 이다. */
export const surfaceRectOnPhoto = (
  surface: Surface,
  photo: PhotoDimensions,
  size: SizeMm,
  position: PlacementPosition,
): PhotoRect | null =>
  surface.type === 'flat' ? componentRectOnPhoto(surface, photo, size, position) : null;

export const surfacePhotoToMm = (
  surface: Surface,
  photo: PhotoDimensions,
  point: SurfacePoint,
): PlacementPosition | null => {
  if (surface.type === 'flat') return photoToSurfaceMm(surface, photo, point);
  if (surface.type === 'cylinder') return cylinderPhotoToMm(surface, photo, point);
  return meshPhotoToMm(surface, photo, point);
};
